module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Preços por canal de venda")]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, _vm._l((_vm.salesChannel), function(saleChannel) {
    return _c('div', {
      staticClass: "l-row saleChannel"
    }, [_c('div', {
      staticClass: "margin l-col-4@md"
    }, [_c('strong', {
      staticClass: "ds-block"
    }, [_vm._v(_vm._s(_vm.$t('saleChannel.label')))]), _vm._v("\n          " + _vm._s(saleChannel.label) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "l-col-12@md"
    }, [_c('price', {
      attrs: {
        "price": saleChannel.price,
        "columnSize": "4"
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn btn--info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Fechar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d54b1ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/ModalSalesChannelPrice.vue
// module id = 3022
// module chunks = 0